import React from 'react';

const GoogleMap = () => {
    return (
        <div
            className="container-xxl py-5 px-0 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{
                visibility: "visible",
                animationDelay: "0.1s",
                animationName: "fadeInUp"
            }}
        >
            <iframe
                title="Google Map of India"
                className="w-100 mb-n2"
                style={{ height: 450 }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3582.4413262467356!2d85.35163727607538!3d26.117149693825194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed179b568c4111%3A0x6a330aaf624a9821!2sYadav%20nagar%20bagwanpur%20Muzaffarpur.!5e0!3m2!1sen!2sin!4v1745156166159!5m2!1sen!2sin"
                frameBorder={0}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex={0}
            />
        </div>
    );
};

export default GoogleMap;
